import React from "react";

export const ProgressBar = ({ currentDay, tone = "light" }) => {
  const days = [1, 2, 3, 4, 5];
  const completedColor = "#B8956A";
  const lockedColor = tone === "dark" ? "rgba(250, 247, 244, 0.2)" : "#EBE5DE";
  const activeRing = tone === "dark" ? "ring-[#FAF7F4]/40" : "ring-[#B8956A]/30";
  const labelColor = tone === "dark" ? "rgba(250, 247, 244, 0.7)" : "rgba(61, 50, 41, 0.55)";

  return (
    <div
      className="flex items-center gap-3"
      data-testid="progress-bar"
      aria-label={`Day ${currentDay} of 5`}
    >
      <div className="flex items-center gap-2">
        {days.map((d) => {
          const isDone = d < currentDay;
          const isActive = d === currentDay;
          return (
            <span
              key={d}
              data-testid={`progress-dot-${d}`}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-500 ${
                isActive ? `ring-2 ring-offset-2 ring-offset-transparent ${activeRing}` : ""
              }`}
              style={{
                background: isDone || isActive ? completedColor : lockedColor,
                transform: isActive ? "scale(1.25)" : "scale(1)",
              }}
            />
          );
        })}
      </div>
      <span
        className="font-body uppercase text-xs tracking-[0.24em]"
        style={{ color: labelColor }}
      >
        Day {currentDay} of 5
      </span>
    </div>
  );
};
